const pmChat = require("./pm-chat-app").default //standard js import
module.exports = pmChat;//webpack library
